import type { RadarFilter } from '@web-platform/shared-universal-types/src/network/endpoints/radar/radarFilterTypes';

export const mapDuration = (stats: RadarFilter | undefined) => {
  if (!stats) return undefined;
  const mappedStats = {
    itineraries: {
      has_city_open_jaw: stats.hasCityOpenJaw,
      max_longest_itinerary_leg_duration: stats.duration.max,
      min_longest_itinerary_leg_duration: stats.duration.min,
      min_duration: stats.duration.multiCityMin,
      max_duration: stats.duration.multiCityMax,
    },
  };

  return mappedStats;
};
